// extracted by mini-css-extract-plugin
export default {"root":"ErrorBoundary__root__HGthZ","reloadBtn":"ErrorBoundary__reloadBtn__K1dfm"};